import { cycloneApiClient } from '@/shared/api/core/axios-instance';

export type TagTypeEnum = 'add' | 'remove';

export type TagItem = {
  tagName: string;
  tagType: TagTypeEnum;
};

export type UpdateEntityTagsRequest = {
  entityType: 'run';
  entityId: number;
  tagList: TagItem[];
};

/**
 * Run의 태그를 일괄 업데이트합니다 (추가 + 삭제를 하나의 API 호출로 처리).
 *
 * @param runId - Run ID
 * @param oldTags - 기존 태그 목록
 * @param newTags - 새로운 태그 목록
 * @returns 성공 시 void, 실패 시 에러 발생
 *
 * @description
 * 1. 추가할 태그: newTags에는 있지만 oldTags에는 없는 태그
 * 2. 삭제할 태그: oldTags에는 있지만 newTags에는 없는 태그
 * 3. 단일 API 호출로 일괄 처리
 */
export const updateRunTags = async (runId: number, oldTags: string[], newTags: string[]): Promise<void> => {
  const oldTagsSet = new Set(oldTags);
  const newTagsSet = new Set(newTags);

  // 추가할 태그 찾기
  const tagsToAdd = newTags.filter((tag) => !oldTagsSet.has(tag));

  // 삭제할 태그 찾기
  const tagsToRemove = oldTags.filter((tag) => !newTagsSet.has(tag));

  // tagList 생성
  const tagList: TagItem[] = [
    ...tagsToAdd.map((tag) => ({ tagName: tag, tagType: 'add' as TagTypeEnum })),
    ...tagsToRemove.map((tag) => ({ tagName: tag, tagType: 'remove' as TagTypeEnum })),
  ];

  // 변경사항이 없으면 바로 리턴
  if (tagList.length === 0) {
    return;
  }

  const requestBody: UpdateEntityTagsRequest = {
    entityType: 'run',
    entityId: runId,
    tagList,
  };

  // 단일 API 호출
  await cycloneApiClient.post('/tags/entity', requestBody);
};
